module.exports = __webpack_public_path__ + "static/media/lua.b343ad5c.svg";